import { render, staticRenderFns } from "./empty-data.vue?vue&type=template&id=79c0c888&"
import script from "./empty-data.component.ts?vue&type=script&lang=ts&"
export * from "./empty-data.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports